/*
|---------------------------------------------------------
| In case we forget to take out console statements.
| IE becomes very unhappy when we forget...
| Let's not make IE unhappy
|---------------------------------------------------------
*/

if(typeof(console) === 'undefined') {
	var console = {};
	console.log = console.error = console.info = console.debug = console.warn = console.trace = console.dir = console.dirxml = console.group = console.groupEnd = console.time = console.timeEnd = console.assert = console.profile = function() {};
}


var isAndroid = /android/i.test(navigator.userAgent.toLowerCase());

var main = function () {

	return {

		/*
		|-----------------------------------------------------
		| Opens external links in new tab or window
		|-----------------------------------------------------
		*/

		openLinkInNewTab: function () {

			var hostname = window.location.hostname;
			$('a[href^="http://"],a[href^="https://"]').not('a[href^="http://'+ hostname +'"],a[href^="https://'+ hostname +'"]').attr('target','_blank');

			$('a[href$=".pdf"]').attr('target', '_blank');
		},

		/*
		|-----------------------------------------------------
		| Replace all form legend with div
		|-----------------------------------------------------
		*/

		replaceLegend: function() {

			$('legend').each(function(){

				var legend = $(this).text();

				$(this).after('<div class="legend">' + legend + '</div>');
				$(this).remove();
			});
		},

		/*
		|-----------------------------------------------------
		| Show submenu on hover menuitem
		|-----------------------------------------------------
		*/

		showSubmenu: function (menuitem) {


			$(menuitem).bind('mouseover', function(){

				if (!$('html').hasClass('mobile')) {

					$(this).addClass('hover');

					var height = $(this).find('.submenu').find('.submenu-item').height();
					height = height * $(this).find('.submenu').find('.submenu-item').length;

					if($(this).find('.submenu').children().length > 0)
					{
						$(this).find('.submenu').stop().animate({
							height: height,
							opacity: 1
						});
					}
				}
			});
			$(menuitem).bind('mouseout',function(){

				if (!$('html').hasClass('mobile')) {

					$(this).removeClass('hover');

					$(this).find('.submenu').stop().animate({
						height: 0,
						opacity: 0
					});
				}
			});
		},

		/*
		|-----------------------------------------------------
		| Show mobile submenu on click menuitem
		|-----------------------------------------------------
		*/

		showMobileMenu: function () {


			$('.mobile-menu-icon').bind('click', function(){

				if ($('#menu').is(':hidden')) {
					$('#menu').fadeIn(300);
					$(this).addClass('active');
				} else {
					$('#menu').fadeOut(300);
					$(this).removeClass('active');
				}
			});
		},

		/*
		|-----------------------------------------------------
		| Show mobile submenu on click menuitem
		|-----------------------------------------------------
		*/

		showMobileSubmenu: function (menuitem) {

			$(menuitem).find('.prevent').parent('li').addClass('prevent');

			$(menuitem).bind('click', function(e){

				if ($('html').hasClass('mobile')) {
					if ($(e.target).parent('li').is(this)) {

						if($(this).find('.submenu').children().length > 0 && $(this).find('.submenu').is(':hidden') && $(this).hasClass('prevent')) {

							$(menuitem).not(this).find('.submenu').slideUp().prev('a').addClass('closed').removeClass('open');
							$(this).find('.submenu').slideDown().prev('a').addClass('open').removeClass('closed');

						} else if ($(this).find('.submenu').children().length > 0 && $(this).find('.submenu').is(':visible') && $(this).hasClass('prevent')) {

							$(this).find('.submenu').slideUp().prev('a').addClass('closed').removeClass('open');
						}
					}
				}
			});

			$(menuitem).find('.submenu-title').bind('click', function() {

				if ($('html').hasClass('mobile')) {

					if($(this).nextAll('li').is(':hidden')) {

						$('.submenu').find('.submenu-title').not(this).nextAll('li').slideUp();
						$('.submenu').find('.submenu-title').not(this).find('a').addClass('closed').removeClass('open');

						$(this).nextAll('li').slideDown();
						$(this).find('a').addClass('open').removeClass('closed');

					} else {

						$(this).nextAll('li').slideUp();
						$(this).find('a').addClass('closed').removeClass('open');
					}
				}
			});

			// $('.mobile #menu > li').bind('click', function(e) {

			// 	if ($(e.target).parent('li').is(this)) {
			// 		if ($(this).children('ul').length) {
			// 			e.preventDefault();
			// 			var ul = $(this).children('ul');
			// 			if (ul.is(':hidden')) {
			// 				$('.mobile #menu > li').not(this).removeClass('open').children('ul').slideUp(200).find('li').removeClass('open').find('ul').slideUp(200);
			// 				$(this).addClass('open');
			// 				ul.slideDown(200);
			// 			} else {
			// 				$(this).removeClass('open');
			// 				$(this).find('li').removeClass('open');
			// 				ul.slideUp(200);
			// 				ul.find('ul').slideUp(200);
			// 			}
			// 		}
			// 	}
			// });
			// $('.mobile #menu > li > ul > li').bind('click', function(e) {

			// 	if ($(e.target).parent('li').is(this)) {
			// 		if ($(this).children('ul').length) {
			// 			e.preventDefault();
			// 			var ul = $(this).children('ul');
			// 			if (ul.is(':hidden')) {
			// 				$('.mobile #menu > li > ul > li').not(this).removeClass('open').children('ul').slideUp(200).find('li').removeClass('open').find('ul').slideUp(200);
			// 				$(this).addClass('open');
			// 				ul.slideDown(200);
			// 			} else {
			// 				$(this).removeClass('open');
			// 				ul.slideUp(200);
			// 			}
			// 		}
			// 	}
			// });
		},

		preventDefault: function(link) {

			$(link).click(function(e){
				e.preventDefault();
			});

		},

		/*
		|-----------------------------------------------------
		| Scrolls back to top
		|-----------------------------------------------------
		*/

		backToTop: function (button) {

			$(button).click(function(e){

				e.preventDefault();

				$('body').animate({
					scrollTop: $('body').offset().top
				}, 1000);
			});
		},

		/*
		|-----------------------------------------------------
		| Create faq accordion
		|-----------------------------------------------------
		*/

		faqAccordion: function (ul) {

			$(ul +' > li span').click(function(){
				var li = $(this).closest('li');
				if(li.children('ul').is(':hidden')){
					$(ul +' > li').removeClass('active').children('ul:not(this)').slideUp(200);
					li.addClass('active').children('ul').slideDown(200);
				}else{
					li.removeClass('active').children('ul').slideUp(200);
				}
			});

			$(ul + ' ul').click(function(e){
				e.stopPropagation();
			});
			
		},

		/*
		|-----------------------------------------------------
		| trigger a tag inside element
		|-----------------------------------------------------
		*/

		triggerAhref: function (elem, a) {

			$(elem).click(function(){

				var href = $(this).find(a).attr('href');

				if(href !== undefined)
				{
					window.location = href;
				}
			});
		},

	};
};

var formstyle =  function () {

	return {

		/*
		|-----------------------------------------------------
		| Sets the uniform function on the given element
		|-----------------------------------------------------
		*/

		setUniform: function (elem) {

			$(elem).uniform();
		},

		/*
		|-----------------------------------------------------
		| Sets the uniform function on the given element
		|-----------------------------------------------------
		*/

		setRadioUniform: function (elem,radioclass) {

			$(elem).uniform({radioClass: radioclass});
		},

		/*
		|-----------------------------------------------------
		| Sets the uniform function on the given element
		|-----------------------------------------------------
		*/

		setSelectUniform: function (elem,selectclass) {

			$(elem).uniform({selectClass: selectclass});
		},

		/*
		|-----------------------------------------------------
		| Sets the slider function on the children of the
		| given parent
		|-----------------------------------------------------
		*//**/

		// setSlider: function (parent, min, max, startVal, step, callback) {

		// 	min = typeof min == 'undefined' ? 0 : min;
		// 	max = typeof max == 'undefined' ? 75000 : max;
		// 	startVal = typeof startVal == 'undefined' ? 0 : startVal;
		// 	step = typeof step == 'undefined' ? 0 : step;

		// 	$(parent + ' .slider').slider({
		// 		range: 'min',
		// 		value: startVal,
		// 		min: min,
		// 		max: max,
		// 		step: step,
		// 		create: function(event, ui) {
		// 			dataHolder = $(this).data('holder');
		// 			$('input[data-holder="'+dataHolder+'"]').val($(this).slider('option', 'value'));
		// 			// $(parent + ' .ui-slider-handle').text('€ ' + $(this).slider('option','value'));
		// 			// $(parent + ' .min').text('€ ' + $(this).slider('option','min'));
		// 			// $(parent + ' .max').text('€ ' + $(this).slider('option','max'));
		// 		},
		// 		start: function(event, ui) {
		// 			$(parent + ' .rails').css({backgroundPosition: '0 -6px'});
		// 		},
		// 		slide: function(event,ui) {
		// 			dataHolder = $(event.target).data('holder');
		// 			$('input[data-holder="'+dataHolder+'"]').val(ui.value);
		// 			changeBedrag();
		// 			// $(parent + ' .ui-slider-handle').text('€ ' + ui.value);
		// 		}
		// 	});
		// }
	};
};

var elemsize = function () {

	return {

		/*
		|-----------------------------------------------------
		| On resize or load the radiobutton and radiolabel
		| will be the same width as the parent
		|-----------------------------------------------------
		*/

		setRadioLabelWidth: function (parent) {

			var w = $(parent).width() - 1;

			$(parent + ' .radio-label').width(w - 40);
		},

		/*
		|-----------------------------------------------------
		| On resize or load the selectbox will be the same
		| width as the parent
		|-----------------------------------------------------
		*/

		setSelectboxWidth: function (parent) {

			var w = $(parent).width() - 1;

			$(parent + ' .selector').width(w - 10);
			$(parent + ' .selector span').width(w - 35);
		},

		/*
		|-----------------------------------------------------
		| Makes columns equal length
		|-----------------------------------------------------
		*/

		makeEqualHeight: function (colgroup,column) {

			$(colgroup).each(function(){

				var height = 0;
				var col = $(this).find(column);
				col.css({height: ''});

				col.each(function(){

					if($(this).height() > height)
					{
						height = $(this).height();
					}
				});

				col.height(height);
			});
		}
	};
};

var tooltipObject = function () {

	return {

		/*
		|-----------------------------------------------------
		| Print tooltip in 'Rente berekening' table
		|-----------------------------------------------------
		*/

		printTooltip: function (elem) {

			$(elem).each(function(){

				var content = $(this).text();
				var box = '<span class="tooltip"><span class="tooltip-arrow" /><span class="tooltip-content">' + content + '</span></span>';

				$(this).parent().append(box);

				$(this).remove();
			});
		},

		/*
		|-----------------------------------------------------
		| Show tooltip on hover
		|-----------------------------------------------------
		*/

		showTooltip: function (elem) {

			$(elem).find('img').mouseenter(function(){

				$(elem).not(this).find('.tooltip').css('display','none');

				if($(this).next('.tooltip').is(':hidden'))
				{
					$(this).next('.tooltip').css('display','block');
				}
			});

			$(elem).find('img').mouseleave(function(){

				$(this).next('.tooltip').css('display','none');
			});
		}
	};
};

/*---------------------------------------------------- */
/* Function to test is if mobile, tablet or desktop
/*---------------------------------------------------- */
var isMobile = {
	mobile: function() {
		if ($(window).innerWidth() < 768)
			return true;
	},
	tablet: function() {
		if ($(window).innerWidth() >= 768 && $(window).innerWidth() < 1200)
			return true;
	}
};

var setDeviceClass = function() {

	/*---------------------------------------------------- */
	/* Gives the html tag a class
	/*---------------------------------------------------- */
	if (isMobile.mobile()) {
		$('html').addClass('mobile').removeClass('tablet desktop');
	} else if (isMobile.tablet()) {
		$('html').addClass('tablet').removeClass('mobile desktop');
	} else {
		$('html').addClass('desktop').removeClass('mobile tablet');
	}

};


var setHeaderHeight = function() {

	if(!$('#header').hasClass('no-size-change')){
		var viewportHeight = $(window).height();
		var menuHeight = $('#top').height();
		var headerPadding = 55;
		var containerHeight = $('div#header-container').outerHeight();

		var newHeaderHeight = viewportHeight - menuHeight - headerPadding - 40;

		if (newHeaderHeight > containerHeight){
			$('div#header').height(newHeaderHeight);
			var containerMargin = (newHeaderHeight-containerHeight) / 2;
			$('#header-container').css('margin-top', containerMargin);
		}

		//position the header container

	}

};

var setImgColHeight = function() {

	$('.cover').each(function(index, el) {
		var textHeight = $(el).parents('div.row').children('.text').outerHeight(true);

		$(el).parents('div.img').css('height', textHeight);
	});

};



/*
|-----------------------------------------------------------
| When DOM is ready
|-----------------------------------------------------------
*/

$(document).ready(function(){

	setDeviceClass();

	setHeaderHeight();

	// initialize sliders met beginwaardes.
	// $('.trigger-box').find('.slider').each(function(){
	// 	var slider = $(this);
	// 	console.log(slider);
	// 	slider.empty().slider({
	// 		range: "min", //slider met minimum waarde
	// 		value: 1000, //begin waarde 1000
	// 		min: 0, //minimaal 0
	// 		max: 5000, //maximaal 5000
	// 		slide: function( event, ui ) { // tijdens het sliden wordt het volgende uitgevoerd

	// 			var id = slider.data('holder'); //haal het id van het corresponderende veld op dat de data moet vasthouden
	// 			// console.log(id);
	// 			$('input#' + id).val(ui.value); //stel het juiste getal in van dit veld
	// 			slider.parents('div.row:first').find('div:last input').val(ui.value); //vul het getal ook in bij het input veld naast de slider
	// 			// changeBedrag(); // verwerk alle data
	// 		}
	// 	});
	// });

	/*-----------------------------------------------------*/
	/* Links with tel: are only clickable on mobile
	/*-----------------------------------------------------*/
	$('html:not(.mobile) a[href^="tel:"]').removeAttr('href');


	var f = formstyle();

	// f.setSelectUniform('.select:not(.select-light)');
	// f.setSelectUniform('.select-gray', 'selector selector-gray');
	// f.setSelectUniform('.select-light', 'selector selector-light');
	// f.setSelectUniform('.selector-mini', 'selector selector-small selector-light');
	// f.setUniform('input[type="radio"]:not(.radio-light)');
	// f.setRadioUniform('input.radio-light', 'radiowrapper-light');
	// f.setUniform('input[type="checkbox"]');
	// f.setSlider('#bereken_lening', 0, 5000, 1500, 25);


	var e = elemsize();

	// e.setRadioLabelWidth('.trigger-box form');
	// e.setSelectboxWidth('.trigger-box form');
	// e.setSelectboxWidth('#middle .column');
	e.makeEqualHeight('.tablet #menu .submenu, .desktop #menu .submenu', 'ul');
	// e.setSelectboxWidth('table td');

	var m = main();

	m.openLinkInNewTab();
	m.backToTop('#backtotop');
	m.replaceLegend();
	m.faqAccordion('#faq');
	m.triggerAhref('.newsitem', '.more');
	// m.showSubmenu('#menu > li');
	m.showMobileMenu();
	// m.showMobileSubmenu('.mobile #menu > li');
	m.preventDefault('a.prevent');

	var t = tooltipObject();

	t.printTooltip('table td.info p');
	t.showTooltip('table td.info');
	t.printTooltip('div.tooltip p');
	t.showTooltip('div.tooltip');


	$('.tooltip').tooltipster();

	addClickMobile();

});

function addClickMobile() {

	if( $(window).width() <= 767 ) {

		$('#menu a').click(function(e){

			if( $(this).next('.submenu').length )
			{
				e.preventDefault();
				$(this).next('.submenu').slideToggle();
			}

		});
	}

}

/*
|-----------------------------------------------------------
| When Content is loaded
|-----------------------------------------------------------
*/

$(window).load(function(){

	var e = elemsize();

	e.makeEqualHeight('.equal-height', '.column');
	e.makeEqualHeight('.equal-height', '.col');
	e.makeEqualHeight('.tablet #menu .submenu, .desktop #menu .submenu', 'ul');

	// e.setSelectboxWidth('table td');
	// e.setRadioLabelWidth('.trigger-box form');
	// e.setSelectboxWidth('.trigger-box form');

	setHeaderHeight();

});

/*
|-----------------------------------------------------------
| On browser resize
|-----------------------------------------------------------
*/

$(window).resize(function(){

	setDeviceClass();

	setHeaderHeight();

	setImgColHeight();

	setHeaderHeight();

	$("div.review p").css('height', 'auto');
	var reviewHeight = Math.max.apply(null, $("div.review p").map(function ()
	{
	    return $(this).height();
	}).get());
	$('div.review p').height(reviewHeight);
	$('.TPscore-box div.review p').css('line-height',reviewHeight+'px');

	/*-----------------------------------------------------*/
	/* Links with tel: are only clickable on mobile
	/*-----------------------------------------------------*/
	$('html:not(.mobile) a[href^="tel:"]').removeAttr('href');


	var e = elemsize();

	e.makeEqualHeight('.equal-height', '.column');
	e.makeEqualHeight('.tablet #menu .submenu, .desktop #menu .submenu', 'ul');
	// e.setRadioLabelWidth('.trigger-box form');
	// e.setSelectboxWidth('.trigger-box form');
	// e.setSelectboxWidth('#middle .column');
	// e.setSelectboxWidth('table td');

});

$(function() {
  $('a[href*="#"]:not([href="#"])').not('.modal-trigger').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });
});


$(document).ready(function(){

	$('input.bedrag').numeric(false); // Make every input with class number a numeric.

	if(typeof $('#header').data('headerimage') !== 'undefined')
	{
		$('#header').css('background','url(/' + $('#header').data('headerimage') + ') center 70% no-repeat');
	}

	var reviewHeight = Math.max.apply(null, $("div.review p").map(function ()
	{
	    return $(this).height();
	}).get());

	$('div.review p').height(reviewHeight);
	$('.TPscore-box div.review p').css('line-height',reviewHeight+'px');

	$('.accordion h3').click(function(e){
		e.preventDefault();
		$(this).next('.item').slideToggle();
		$(this).toggleClass('dropdown-open');
	});

	$('.read-more .toggle').click(function(e){
		e.preventDefault();
		$(this).parent().find('.item').slideToggle();
		$(this).parent().find('.toggle').hide();
	});

	$('div.text').on('click', '.close', function(e){
		e.preventDefault();
		$(this).parent().fadeOut('400', function() {
			//nothing
		});
	});

	$('#rentetabelSelector').on('change', function(){
		var index = $('#rentetabelSelector').children('option:selected').index();
		$(this).parent('form').parent().children('.table-wrapper').hide();
		$(this).parent('form').parent().children('.table-wrapper').eq(index).show();

		var scrollableTr = $('div.scrollable > table > tbody tr:visible');
		var pinnedTr = $('div.pinned > table > tbody tr:visible');

		for(i = 0; i < pinnedTr.length; i++){
			$(pinnedTr[i]).height($(scrollableTr[i]).height());	
		}

	});

	$('#rentetabelSelector').change();

	$('a.scroll_to').on('click', function(event) {
		event.preventDefault();
		$('html, body').animate({
	        scrollTop: $("div.start-of-content").offset().top
	    }, 1500, 'swing');
	});

	//form submit
	$('form#reactie-form').validationEngine();
	$('form#reactie-form').find('submit').click(function(event){
	 	event.preventDefault();
    	if($('form#reactie-form').validationEngine('validate'))
    	{
    		$('form#reactie-form').submit();
    	}
    });

    $.expr[":"].contains = $.expr.createPseudo(function(arg) {
	    return function( elem ) {
	        return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
	    };
	});

    $('input#plaatsInput').on('keyup', function(event) {

    	plaatsVal = $(this).val();
    	if(plaatsVal === '')
    	{
    		$('table#plaatsen').find('tr').show();
    	}else{
	    	$('table#plaatsen').find('a:not(:contains("'+plaatsVal+'"))').parents('tr').hide();
	    	$('table#plaatsen').find('a:contains("'+plaatsVal+'")').parents('tr').show();
	    }
    });

    if($('#right-column').hasClass('center-column') && !$('html').hasClass('mobile'))
    {
    	$('#right-column').css('margin-left', '16.6666665%');
    }else if($('#right-column').hasClass('center-column')){
    	$('#right-column').css('margin-left', 0);
    }

    $('input.numeric.no-decimal').numeric(false);

    if (isAndroid)
    {
        $('input.datum').attr('placeholder', '99-99-9999');
    }else{
        $('input.datum').mask('99-99-9999');
    }

    $('.cover').cover({backgroundPosition:"center"});

    if($('#tools').length === 0 && !$('body').hasClass('offerte'))
    {
    	$('#header').removeClass('margin-bottom');

    	if($('html').hasClass('mobile')){

    	}else{
    		$('#content').css('padding', '0px');
    	}


    }


   	setImgColHeight();

	var scrollDirection = 'down';
    var prevSct = 0;
    var top = parseInt($('#banner').outerHeight());
	var topHeight = top + parseInt($('#top').outerHeight());
	var init = top;
	var position = 'absolute';

    $(window).bind('scroll', function() {

    	var sct = parseInt($(window).scrollTop());

    	if (scrollDirection == 'down') {

	    	if (sct <= topHeight) {
	    		position = 'absolute';
	    		top = init;

	    	} else if (sct > topHeight) {
	    		position = 'fixed';
	    		top = - topHeight + init;

	    		setTimeout(function() {
	    			$('#top').addClass('transition-on');
	    		},5);
	    	}

	    } else if (scrollDirection == 'up') {

	    	if (sct <= init) {
	    		position = 'absolute';
	    		top = init;

	    		$('#top').removeClass('transition-on');

	    	} else if (sct > init) {
	    		position = 'fixed';
	    		top = 0;

	    	}

	    }

	    if (sct > prevSct && scrollDirection != 'down') {
    		scrollDirection = 'down';

    		$('#menu > li').removeClass('hover');

   //  		$('.tablet .submenu, .desktop .submenu').animate({
			// 	height: 0,
			// 	opacity: 0
			// });
			// $('.tablet .submenu-container, .desktop .submenu-container').animate({
			// 	height: 0
			// });

	    } else if (sct < prevSct &&  scrollDirection != 'up') {
	    	scrollDirection = 'up';
	    }

	    prevSct = sct;

    	$('#top').css({
    		position: position,
			top: top
		});


    });

    $('.besparen-box input.bedrag').numeric(false); // Make every input with class number a numeric.

});
  // responsive table
            $(document).ready(function() {
              var switched = false;
              var updateTables = function() {
                if (($(window).width() < 767) && !switched ){
                  switched = true;
                  $("table.responsive").each(function(i, element) {
                    splitTable($(element));
                  });
                  return true;
                }
                else if (switched && ($(window).width() > 767)) {
                  switched = false;
                  $("table.responsive").each(function(i, element) {
                    unsplitTable($(element));
                  });
                }
              };
              
                if ($('html').hasClass('ie9')) {
                    $('a[href^="tel:"]').removeAttr('href');
                }

              $(window).load(updateTables);
              $(window).on("redraw",function(){switched=false;updateTables();}); // An event to listen for
              $(window).on("resize", updateTables);

                function splitTable(original)
                {
                    original.wrap("<div class='table-wrapper' />");

                    var copy = original.clone();
                    copy.find("td:not(:first-child), th:not(:first-child)").css("display", "none").addClass("hide-on-mobile");
                    copy.removeClass("responsive");

                    original.closest(".table-wrapper").append(copy);
                    copy.wrap("<div class='pinned' />");
                    original.wrap("<div class='scrollable' />");

                setCellHeights(original, copy);
                }

                function unsplitTable(original) {
	                original.closest(".table-wrapper").find(".pinned").remove();
	                original.unwrap();
	                original.unwrap();
                }

              function setCellHeights(original, copy) {
                var tr = original.find('tr'),
                    tr_copy = copy.find('tr'),
                    heights = [];

                tr.each(function (index) {
                  var self = $(this),
                      tx = self.find('th, td');

                  tx.each(function () {
                    var height = $(this).outerHeight(true);
                    heights[index] = heights[index] || 0;
                    if (height > heights[index]) heights[index] = height;
                  });

                });

                tr_copy.each(function (index) {
                  $(this).height(heights[index]);
                });
              }

            });